import { render, staticRenderFns } from "./CancelAppointmentModal.vue?vue&type=template&id=54530a03&"
import script from "./CancelAppointmentModal.vue?vue&type=script&lang=ts&"
export * from "./CancelAppointmentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports